import React from 'react'
import { css } from '@emotion/core'
import { Separator } from '@fs/zion-ui'
import { FormCheckbox } from '@fs/zion-form'
import { dataSharedPrivateLabel } from '../../commonStrings'

const dialogContentCss = css`
  margin-top: -10px;
`

const PrivateCheckbox = ({ name, id }) => {
  return (
    <div css={dialogContentCss}>
      <FormCheckbox label={dataSharedPrivateLabel()} name={name} id={id} />
      <Separator size="sm" />
    </div>
  )
}

export default PrivateCheckbox
